import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core';

//////////////////////////

const MainHeading = props => {

  const theme = useTheme();

  return ( <>
    <Typography
      variant = "h1"
      style = {{
        color: theme.palette.primary.contrastText,
      }}
      >
      Project Template
    </Typography>
  </> );
  
};

export default MainHeading;
